export default "__VITE_ASSET__DElldTAQ__"